/* Sop. Essential · añadido rápido y envío gratis de la ficha de producto (snippets/sop-pdp-upsell.liquid)
 * Va encima de sop-pdp.js sin cambiarlo:
 * - Cada extra pide "¿Cómo lo quieres?" y solo cuenta (aria-pressed="true", que es lo que lee sop-pdp.js
 *   para el carrito y el envío) al pulsar "Confirmar y añadir".
 * - Envío gratis: lo que falta ahora según el carrito real (leído en directo) y lo que faltaría con este producto.
 */
(function () {
  'use strict';
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function money(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }

  // Texto del envío gratis. cart: lo que ya hay en el carrito; plus: lo que se añadiría; what: "este producto"…
  function shipText(cart, plus, free, what) {
    var now = free - cart, after = now - plus;
    if (now <= 0) return '<b>Envío gratis</b>: ya lo tienes con lo que llevas en el carrito.';
    if (cart <= 0) {
      return after <= 0 ? 'Con ' + what + ' tienes el <b>envío gratis</b>.'
        : 'Envío gratis desde ' + money(free) + '. Con ' + what + ' te faltarían <b>' + money(after) + '</b>.';
    }
    return 'En tu carrito llevas ' + money(cart) + ': te faltan <b>' + money(now) + '</b> para el envío gratis.' +
      (after <= 0 ? ' Con ' + what + ', <b>ya lo tienes</b>.' : ' Con ' + what + ' te quedarían <b>' + money(after) + '</b>.');
  }

  // El envío de sop-pdp.js, con el carrito leído en directo y el texto claro
  function patchShip(root) {
    var p = root._sp;
    if (!p || p._shipOk) return;
    p._shipOk = true;
    p.renderShip = function () {
      var box = this.root.querySelector('[data-sp-ship]');
      if (!box || !this.data.freeShipping) return;
      var free = this.data.freeShipping, cart = this.cartTotal || 0, extras = this.extrasTotal();
      var plus = this.variant.price + extras;
      box.querySelector('[data-ship-bar]').style.width = Math.min(100, Math.round((cart + plus) * 100 / free)) + '%';
      box.classList.toggle('is-ok', cart + plus >= free);
      box.querySelector('[data-ship-text]').innerHTML = shipText(cart, plus, free, extras ? 'este producto y los extras' : 'este producto');
    };
    function refresh() {
      fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { p.cartTotal = c.total_price || 0; p.renderShip(); })
        .catch(function () {});
    }
    p.renderShip();
    refresh();
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    document.addEventListener('cart:refresh', refresh);
  }

  // Deja la caja a la vista bajo la cabecera y por encima de la barra fija, sin abrir el teclado
  function reveal(root, el) {
    var bar = root.querySelector('[data-sp-bar]'), r = el.getBoundingClientRect();
    var barH = bar && getComputedStyle(bar).position === 'fixed' && bar.classList.contains('is-on') ? bar.offsetHeight : 0;
    var top = 90, bottom = window.innerHeight - barH - 12;
    var dy = r.bottom > bottom ? r.bottom - bottom : 0;
    if (r.top - dy < top) dy = r.top - top;
    if (dy) window.scrollBy({ top: dy, behavior: 'smooth' });
  }

  function setup(root, li) {
    if (li._up) return;
    li._up = true;
    var btn = li.querySelector('[data-up-toggle]'), cfg = li.querySelector('[data-up-cfg]');
    var note = li.querySelector('[data-up-note]'), done = li.querySelector('[data-up-done]');
    var state = 'off';
    function set(s) {
      state = s;
      li.classList.toggle('is-on', s === 'on');
      li.classList.toggle('is-cfg', s === 'cfg');
      btn.hidden = s === 'cfg';
      btn.setAttribute('aria-pressed', s === 'on' ? 'true' : 'false');
      btn.textContent = s === 'on' ? 'Quitar' : 'Añadir';
      if (cfg) { cfg.hidden = s !== 'cfg'; note.hidden = false; }
      if (done) {
        var n = cfg && note.value.trim();
        done.hidden = s !== 'on';
        done.innerHTML = '<b>Va con tu pedido</b>' + (n ? ' · ' + esc(n) : '') + (cfg ? ' <button type="button" class="sk-link" data-up-edit>Cambiar</button>' : '');
      }
      if (root._sp) root._sp.renderShip();
    }
    // En captura: el clic en "Añadir" no llega al manejador de sop-pdp.js
    li.addEventListener('click', function (e) {
      if (e.target.closest('[data-up-toggle]')) {
        e.stopPropagation();
        if (state === 'on') set('off');
        else if (cfg) { set('cfg'); reveal(root, cfg); }
        else set('on');
      } else if (e.target.closest('[data-up-ok]')) set('on');
      else if (e.target.closest('[data-up-cancel]')) set('off');
      else if (e.target.closest('[data-up-edit]')) { set('cfg'); reveal(root, cfg); }
    }, true);
    if (cfg) {
      note.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); set('on'); } });
      // Mientras se escribe, la barra fija se aparta (móvil)
      note.addEventListener('focus', function () { root.classList.add('sp-typing'); });
      note.addEventListener('blur', function () { setTimeout(function () { root.classList.remove('sp-typing'); }, 150); });
    }
    // sop-pdp.js lo deja todo en "Añadir" cuando ya ha metido los extras en el carrito
    new MutationObserver(function () {
      if (state === 'on' && btn.getAttribute('aria-pressed') !== 'true') set('off');
    }).observe(btn, { attributes: true, attributeFilter: ['aria-pressed'] });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp]'), function (root) {
      patchShip(root);
      Array.prototype.forEach.call(root.querySelectorAll('[data-up]'), function (li) { setup(root, li); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();